import { render } from "./OptIn.vue?vue&type=template&id=2eec2acc&scoped=true"
import script from "./OptIn.vue?vue&type=script&lang=js"
export * from "./OptIn.vue?vue&type=script&lang=js"

import "./OptIn.vue?vue&type=style&index=0&id=2eec2acc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eec2acc"]])

export default __exports__